import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import Navbar from './components/Navbar';
import PWABanner from './components/PWABanner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Archive from './pages/Archive';
import System from './pages/System';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Modem from './pages/Modem';
import './App.css';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function Layout({ children }: { children: React.ReactNode }) {
  return <div className="app-layout"><Navbar /><PWABanner /><main>{children}</main></div>;
}

export default function App() {
  const { fetchMe } = useAuthStore();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetchMe().finally(() => setChecking(false));
  }, [fetchMe]);

  if (checking) {
    return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#080c10', fontFamily:"'Share Tech Mono',monospace", color:'#4a6070', fontSize:14 }}>...</div>;
  }

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ style: { background: '#0d1318', color: '#c8d8e8', border: '1px solid #1a2530', fontFamily: "'Share Tech Mono', monospace", fontSize: '14px' } }} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/archive" element={<PrivateRoute><Layout><Archive /></Layout></PrivateRoute>} />
        <Route path="/system" element={<PrivateRoute><Layout><System /></Layout></PrivateRoute>} />
        <Route path="/analytics" element={<PrivateRoute><Layout><Analytics /></Layout></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Layout><Settings /></Layout></PrivateRoute>} />
        <Route path="/modem" element={<PrivateRoute><Layout><Modem /></Layout></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
